export default "__VITE_ASSET__a1357e36__"